import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary">
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          <img
            src="https://okrj.files.wordpress.com/2021/07/ezgif-7-7a1a9fb118d3.gif"
            alt="Bootstrap"
            width="44"
            height="44"
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/chart">
                Chart
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/line">
                Line
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/file">
                File
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/custom">
                Custom Chart
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/analyzer">
                Analyzer
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/analyzer2">
                Analyzer 2.0
              </Link>
            </li>
          </ul>
          <form className="d-flex" role="search">
            <input
              className="form-control me-2"
              type="search"
              placeholder="Search"
              aria-label="Search"
            />
            <button className="btn btn-outline-success" type="submit">
              Search
            </button>
          </form>
        </div>
      </div>
    </nav>
  );
}
